import { useState } from 'react';
import { usePopper } from 'react-popper';
const sameWidthModifier = {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => {
        state.elements.popper.style.width = `${state.elements.reference.getBoundingClientRect().width}px`;
    },
};
function getOffsetModifier(offset) {
    return {
        name: 'offset',
        options: {
            offset: [0, offset],
        },
    };
}
export function useModifiedPopper(options) {
    const { offset, placement, sameWidth } = options;
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const modifiers = [];
    if (sameWidth) {
        modifiers.push(sameWidthModifier);
    }
    if (offset) {
        modifiers.push(getOffsetModifier(offset));
    }
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement,
        strategy: 'fixed',
        modifiers,
    });
    return {
        setReferenceElement,
        setPopperElement,
        popperProps: {
            style: styles.popper,
            ...attributes.popper,
        },
    };
}
//# sourceMappingURL=useModifiedPopper.js.map